import React, {Component} from 'react';


class Error404 extends Component {
    render(){
        return(
            <center><h1>Error 404: Page not found</h1></center>
        );
    }
}

export default Error404;